/** UI metadata only: bankLabel remains the name in the Banking HTTP contract. */
export interface BankOption {
  country: string;
  code: string;
  name: string;
}

/** Add future countries here, keeping codes textual and scoped by country. */
export const bankOptions: readonly BankOption[] = [
  { country: "CL", code: "001", name: "Banco de Chile" },
  { country: "CL", code: "009", name: "Banco Internacional" },
  { country: "CL", code: "012", name: "Banco Estado" },
  { country: "CL", code: "014", name: "Scotiabank" },
  { country: "CL", code: "016", name: "Banco de Credito e Inversiones" },
  { country: "CL", code: "028", name: "Banco Bice" },
  { country: "CL", code: "031", name: "HSBC" },
  { country: "CL", code: "037", name: "Banco Santander" },
  { country: "CL", code: "039", name: "Banco Itau" },
  { country: "CL", code: "049", name: "Banco Security" },
  { country: "CL", code: "051", name: "Banco Falabella" },
  { country: "CL", code: "053", name: "Banco Ripley" },
  { country: "CL", code: "055", name: "Banco Consorcio" },
  { country: "CL", code: "672", name: "Coopeuch" },
  { country: "CL", code: "697", name: "Inversiones La Polar" },
  { country: "CL", code: "729", name: "Prepago Los Heroes" },
  { country: "CL", code: "730", name: "Tenpo Prepago" },
  { country: "CL", code: "732", name: "Caja Los Andes" },
  { country: "CL", code: "738", name: "Global66" },
  { country: "CL", code: "741", name: "CopecPay" },
  { country: "CL", code: "743", name: "Prex" },
  { country: "CL", code: "746", name: "Fintual" },
  { country: "CL", code: "875", name: "Mercado Pago" },
];

export function filterBankOptions(
  query: string,
  options: readonly BankOption[] = bankOptions,
): readonly BankOption[] {
  const substring = query.toLowerCase();
  return options.filter((option) =>
    option.name.toLowerCase().includes(substring),
  );
}
